(() => {
  if (window.portraitVideoCardsReady) return;
  window.portraitVideoCardsReady = true;

  const init = (root = document) => {
    root.querySelectorAll('.creator-program-video-card video').forEach((video) => {
      if (video.dataset.creatorVideoReady === 'true') return;
      video.dataset.creatorVideoReady = 'true';
      video.controls = false;
      video.muted = true;
      if (video.readyState === 0) video.load();
      const preview = video.play();
      if (preview && typeof preview.then === 'function') {
        preview.then(() => {
          window.setTimeout(() => {
            if (video.dataset.creatorUserPlayed === 'true') return;
            video.pause();
            video.muted = false;
          }, 1000);
        }).catch(() => { video.muted = false; });
      }
    });
  };

  const updateControl = (video, isPlaying) => {
    const control = video.closest('.creator-program-video-card')?.querySelector('.creator-program-video-card__control');
    if (!control) return;
    control.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
    control.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
  };

  document.addEventListener('click', (event) => {
    const card = event.target.closest('.creator-program-video-card');
    if (!card) return;
    if (event.target.closest('.creator-program-video-card__caption')) return;
    const video = card.querySelector('video');
    if (!video) return;
    if (video.paused) {
      video.dataset.creatorUserPlayed = 'true';
      video.muted = false;
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    } else {
      video.pause();
    }
  });

  document.addEventListener('play', (event) => {
    if (event.target.matches('.creator-program-video-card video')) {
      event.target.closest('.creator-program-video-card').classList.add('is-playing');
      updateControl(event.target, true);
    }
  }, true);
  document.addEventListener('pause', (event) => {
    if (event.target.matches('.creator-program-video-card video')) {
      event.target.closest('.creator-program-video-card').classList.remove('is-playing');
      updateControl(event.target, false);
    }
  }, true);
  document.addEventListener('ended', (event) => {
    if (event.target.matches('.creator-program-video-card video')) {
      event.target.closest('.creator-program-video-card').classList.remove('is-playing');
      updateControl(event.target, false);
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
